<template>
	<div class="name" @click="selectCurWidget">
		{{ me.type }}
	</div>
	<button v-if="me.type === widgetType.STACK" @click="isShow = !isShow">{{ isShow ? 'v' : '>' }}</button>
	<div v-if="me.type === widgetType.STACK">
		<div class="node" v-for="node in me.realNodes" :key="node.id" v-show="isShow">
			<Node :me="node" />
		</div>
	</div>
</template>

<script lang="ts">
import { dataKey, State, Widget, widgetType } from '@/types';
import { defineComponent, inject, PropType, reactive, ref } from 'vue';
export default defineComponent({
	props: {
		me: {
			type: Object as PropType<Widget>,
			required: true,
		},
	},
	setup(props) {
		const me = reactive(props.me);
		const isShow = ref(false);
		const state: State = inject<any>(dataKey.STATE);

		// 处理选中
		const selectCurWidget = (e: MouseEvent) => {
			e.stopPropagation();
			e.preventDefault();
			state.curWidget = me;
		};

		return { widgetType, isShow, selectCurWidget };
	},
});
</script>

<style scoped>
.name {
	display: inline-block;
	border: black solid 1px;
}
.node {
	margin-left: 20px;
}
</style>
